module.exports = __webpack_public_path__ + "img/au_5.c012ccb0.webp";